module.exports = __webpack_public_path__ + "media/images/categoryIcons/trump_impeachment_icon-a94fe166eb2ccaa97e7e27ec0fe83d2a.svg";